module.exports = __webpack_public_path__ + "img/chart-ozkaynak.b55c4d62.png";